import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const ADVANTAGE = 'Advantage';
const PREMIER = 'Premier';

const experimentPackageCopy = {
  ADVANTAGE_MONTHLY: {
    id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageMonthly',
    defaultMessage: ADVANTAGE,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageMonthly',
      message: '[Type: Heading][Vis.: high] - Advantage Monthly package name heading',
      project: PROJECT_NAME,
    },
  },
  ADVANTAGE_ANNUAL: {
    id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageAnnual',
    defaultMessage: ADVANTAGE,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageAnnual',
      message: '[Type: Heading][Vis.: high] - Advantage Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  PREMIER_ANNUAL: {
    id: 'Pricing.experimentPackageCopy.SharedPagesPremierAnnual',
    defaultMessage: PREMIER,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesPremierAnnual',
      message: '[Type: Heading][Vis.: high] - Premier Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  TEAM_ADVANTAGE: {
    id: 'Pricing.experimentPackageCopy.SharedPagesTeamAdvantage',
    defaultMessage: 'Team Advantage',
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesTeamAdvantage',
      message: '[Type: Heading][Vis.: high] - Team Advantage package name heading',
      project: PROJECT_NAME,
    },
  },
  TEAM_PREMIER: {
    id: 'Pricing.experimentPackageCopy.SharedPagesTeamPremier',
    defaultMessage: 'Team Premier',
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesTeamPremier',
      message: '[Type: Heading][Vis.: high] - Team Premier package name heading',
      project: PROJECT_NAME,
    },
  },
  GROW_2792_ENT_PLATINUM_BYLINE: {
    id: 'Pricing.experimentPackageCopy.Grow2792EnterpriseByline',
    defaultMessage: 'Admin controls, integrations and security features for your organization. ',
    desc: {
      id: 'Pricing.experimentPackageCopy.Grow2792EnterpriseByline',
      message: '[Type: Text][Vis: high] - Grow-2792 Enterprise pricing byline',
      project: PROJECT_NAME,
    },
  },
};

export default experimentPackageCopy;
